
const routes = {
  'default': '/',
  'about': '/about',
  'contact': '/contact',
};

export default routes;